import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { VisualizationHistoryItem } from 'src/app/models/visualization-history';
import { Util } from 'src/app/util';

@Component({
  selector: 'app-user-visualization-history-item',
  templateUrl: './user-visualization-history-item.component.html',
  styleUrls: ['./user-visualization-history-item.component.scss'],
})
export class UserVisualizationsHistoryItemComponent implements OnInit {
  @Input()
  item: VisualizationHistoryItem;

  @Output()
  removed = new EventEmitter<VisualizationHistoryItem>();

  slug: string;

  constructor() {}

  ngOnInit() {
    this.slug = Util.slugify(this.item.title + '-' + this.item.recordId);
  }

  onRemoved(item: VisualizationHistoryItem) {
    this.removed.emit(item);
  }
}
